
import router from '@/router'

import __C from '../../primitives/_constant_'
import { AccountService, ApplicationService } from '@/services'

const ACCOUNT = JSON.parse(localStorage.getItem('ACCOUNT'))
const accountService = new AccountService()
const applicationService = new ApplicationService()
const SHOW_LOCAL_LOGIN = localStorage.getItem('showLocalLogin') === 'true'

const state = !!ACCOUNT
    ? {
      status: { loggedIn: true },
      account: ACCOUNT,
      isAdmin: ACCOUNT.userPermit.split(',').some(r => __C.FULL_ACCESS_PERMISSION.indexOf(r) >= 0),
      fullAccess: !ACCOUNT.userPermit,
      showLocalLogin: SHOW_LOCAL_LOGIN // Add showLocalLogin state
    } : {
      status: {},
      account: null,
      fullAccess: false,
      showLocalLogin: SHOW_LOCAL_LOGIN // Add showLocalLogin state
    }
const mutations = {
  signinRequest(state, account) {
    state.status = { loggedIn: true }
    state.account = account
    state.isAdmin = account.userPermit.split(',').some(r => __C.FULL_ACCESS_PERMISSION.indexOf(r) >= 0)
    state.fullAccess = !account.userPermit
  },
  signinSuccess(state, account) {
    state.status = { loggedIn: true }
    state.account = account
    state.isAdmin = account.userPermit.split(',').some(r => __C.FULL_ACCESS_PERMISSION.indexOf(r) >= 0)
    state.fullAccess = !account.userPermit
  },
  signout(state) {
    state.status = {}
    state.account = null
    state.isAdmin = false
    state.fullAccess = false
  },
  // Add new mutation for showLocalLogin
  SET_SHOW_LOCAL_LOGIN(state, value) {
    state.showLocalLogin = value
  }
}
const getters = {
  getToken: (state) => {
    return state.account
  }
}
const actions = {
  // signin({ dispatch, commit, getters }, creds) {
  signin({ commit }, creds) {
    // console.log(`[ACCOUNT #MODULE#] signin`, creds)
    // alert(`[ACCOUNT #MODULE#] signin`)
      // commit('signinRequest', creds)
    return new Promise(resolve => {
      accountService.signin(creds, account => {
        if(account.token) {
          commit('signinSuccess', account)
          resolve(account)
        } else {
          // commit('signinFailure', error);
          // dispatch('alert/error', error, { root: true });
          resolve(account)
        }
      })
    })
  },
  signrts({ commit }, creds) {
    // console.log(`[ACCOUNT #MODULE#] signin`, creds)
    // alert(`[ACCOUNT #MODULE#] signin`)
      // commit('signinRequest', creds)
    return new Promise(resolve => {
      accountService.signrts(creds, account => {
        if(account.token) {
          console.log('module',account)
          // account.user.userPermit = 'SYS_ADMIN'
          commit('signinSuccess', account)
          resolve(account)
        } else {
          // commit('signinFailure', error);
          // dispatch('alert/error', error, { root: true });
          resolve(account)
        }
      })
    })
  },
  signms({ commit }, creds) {
    // commit('signinRequest', creds)
    //alert(`[ACCOUNT #MODULE#]`)
    return new Promise(resolve => {
      accountService.signms(creds, account => {
        // console.log(`[ACCOUNT #MODULE#]`, creds)
        if(!!account.token) {
          commit('signinSuccess', account)
          resolve(account)
        } else {
          // commit('signinFailure', error);
          // dispatch('alert/error', error, { root: true });
          resolve(account)
        }
      })
    })
  },
  signout({ commit }) {
    accountService.signout(() => {
      commit('signout')

      window.location.href = __C.CONFIG.FOR_LOCAL || state.showLocalLogin ? __C.HOST_NAME : `${__C.LANDING_PAGE_NAME}/logout.html?signout=true`
      //window.location.href = `https://login.coresoft.kr:8443/realms/jwcnioos/protocol/openid-connect/logout?post_logout_redirect_uri=${encodeURIComponent('https://jwcnioos.coresoft.kr/auth/callback.html?signout=true')}`;
      // router.replace('/signin', () => {})
    })
  },
  putRequestHistory({ state }, params) {
    let reqInfo = {
      userId: state.account.id,
      ...params
    }
    return new Promise(resolve => {
      if(!state.status || !state.status.loggedIn) resolve(null)
      else applicationService.putRequestHistory(reqInfo).then(res => {
        resolve(res)
      })
    })
  },
  LevedRequestHistory({ state }, params) {
    let reqInfo = {
      userId: state.account.id,
      ...params
    }
    return new Promise(resolve => {
      if(!state.status || !state.status.loggedIn) resolve(null)
      else applicationService.LevedRequestHistory(reqInfo).then(res => {
        resolve(res)
      })
    })
  },
  // Add new actions for showLocalLogin
  setShowLocalLogin({ commit }, value) {
    localStorage.setItem('showLocalLogin', value)
    commit('SET_SHOW_LOCAL_LOGIN', value)
  },
  initializeLoginForm({ commit }) {
    const savedShowLocalLogin = localStorage.getItem('showLocalLogin')
    if (savedShowLocalLogin !== null) {
      commit('SET_SHOW_LOCAL_LOGIN', __C.CONFIG.FOR_LOCAL )
    }
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}
